export const PROFILES = {
    'seizure-safe-profile': {
      "contrast": 'low-saturation',
      "tools": ['stop-animations'],
    },
    'adhd-profile': {
      "contrast": 'high-saturation',
      "tools": ['stop-animations','readable-guide']
    },
    'cognitive-disabilities-profile': {
      "tools": ['stop-animations','highlight-links','highlight-title']
    }
}